import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

const SelectSwitch = (props) => {
  // ↓埋め込み先で必要なコード(例)↓
  // const [release, setRelease] = useState(false);
  // const handleChange = (event) => {
  //   setRelease({ ...release, [event.target.name]: event.target.checked });
  // };
  return (
    <div className="center">
      <FormControlLabel
        control={<Switch checked={props.checked} onChange={props.onChange} name={props.name} />}
        label={props.label}
      />
    </div>
  );
};
export default SelectSwitch;
